import { Pipe, PipeTransform } from '@angular/core';
import { format } from 'date-fns';

@Pipe({
    name: 'dateFns'
})
export class DateFnsPipe implements PipeTransform {
    public transform(value: any, dateFnsFormat: string): string {
        return !!value ? format(value, dateFnsFormat) : '';
    }
}
